import { useEffect, useState } from 'preact/hooks';

export default function useMediaQuery(query: string) {
  if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined')
    return false;

  const mediaQuery = window.matchMedia(query);
  const [match, setMatch] = useState(!!mediaQuery.matches);

  useEffect(() => {
    const handler = () => setMatch(!!mediaQuery.matches);
    mediaQuery.addListener(handler);
    return () => mediaQuery.removeListener(handler);
  }, []);

  return Boolean(match);
}
